/**
 * ConditionInspector — Phase 5a-5.
 *
 * Edits if/else branching node config. V3's condition node has a single
 * configurable field: `expression` (JavaScript boolean expression evaluated
 * against input data). True/False routing is encoded as the node's two
 * output ports (handled by the canvas connection model, not this editor).
 *
 * Spread-preservation contract identical to HTTP/LLM editors.
 */

import React from 'react';

export default function ConditionInspector({ node, onUpdate, readOnly = false }) {
  const cfg = node.config || {};
  const expression = cfg.expression || '';

  const setField = (key, value) => {
    if (readOnly || typeof onUpdate !== 'function') return;
    onUpdate(node.id, { config: { ...cfg, [key]: value } });
  };

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 14 }}>
      <label style={{ display: 'flex', flexDirection: 'column', gap: 4 }}>
        <span style={{ fontSize: 11, fontWeight: 600, color: '#0f172a' }}>Expression</span>
        <textarea
          value={expression}
          onChange={(e) => setField('expression', e.target.value)}
          placeholder='result.score > 0.8 && result.severity === "high"'
          disabled={readOnly}
          rows={4}
          style={{
            width: '100%', padding: '6px 8px',
            fontSize: 11, color: '#0f172a',
            background: '#ffffff',
            border: '0.5px solid #cbd5e1', borderRadius: 4,
            outline: 'none',
            fontFamily: 'SFMono-Regular, Menlo, monospace',
            lineHeight: 1.5,
          }}
        />
        <span style={{ fontSize: 10, color: '#64748b' }}>
          JavaScript expression evaluated against input data. True → true port; false → false port.
        </span>
      </label>

      <div style={{
        padding: 10,
        background: '#f1f5f9',
        borderRadius: 6,
        fontSize: 11,
        color: '#0f172a',
        lineHeight: 1.6,
      }}>
        <div style={{ fontWeight: 600, marginBottom: 6 }}>Output ports</div>
        <div style={{ display: 'flex', gap: 12 }}>
          <span><span style={portDot('#78716c')} /> <code style={portCode}>true</code></span>
          <span><span style={portDot('#ef4444')} /> <code style={portCode}>false</code></span>
        </div>
        <div style={{ fontSize: 10, color: '#64748b', marginTop: 6 }}>
          Wire downstream nodes to each port on the canvas. Connection ports are
          configured by drawing edges, not in this panel.
        </div>
      </div>
    </div>
  );
}

const portDot = (bg) => ({
  display: 'inline-block', width: 8, height: 8, borderRadius: '50%',
  background: bg, marginRight: 4, verticalAlign: -1,
});
const portCode = {
  background: '#fff', padding: '1px 5px', borderRadius: 3,
  fontFamily: 'SFMono-Regular, Menlo, monospace', fontSize: 10,
  color: '#0f172a', border: '0.5px solid #cbd5e1',
};
